export const ResetAttributesService = {
  attributesToReset(attr, value) {
    if (!this.isNeedToReset(attr, value)) return [];
    switch (attr) {
      case "age_requirement_employee_deferrals":
        return ["age_requirement_years", "age_requirement_months", "age_requirement_sync"];
      case "service_requirement_employee_deferrals":
        return ["service_requirement_measurement_number", "service_requirement_sync"];
      case "employee_contrib_pretax_yesno":
        return ["employee_contrib_pretax_max_contribution_percent"];
      case "employee_contrib_roth_yesno":
        return ["employee_contrib_roth_max_contribution"];
      case "employee_contrib_aftertax_yesno":
        return ["employee_contrib_aftertax_max_contribution"];
      case "employee_contrib_is_combined_max_yesno":
        return ["employee_combined_max_contribution"];
      case "employee_contrib_plan_uses_autoenroll_picklist_id":
        return [
          "initial_deferral_rate_autoenroll",
          "effective_date_autoenroll",
          "auto_enroll_type",
          "auto_enrollment_applies_prior_employees"
        ];
      case "auto_increase_available":
        return [
          "auto_increase_effective_date",
          "auto_increase_type",
          "auto_increase_annual_increase",
          "auto_increase_maximum",
          "auto_increase_applies_prior_employees",
          "auto_increase_date_type"
        ];
      case "age_requirement_employer_match":
        return ["age_requirement_match_years", "age_requirement_match_months"];
      case "service_requirement_employer_match":
        return ["service_requirement_match_measurement_number"];
      case "employer_match_dollar_maximum":
        return ["match_dollar_limit_amount"];
      case "employer_match_annual_service_reqt":
        return ["match_hours_requirement"];
      case "employer_match_true_up":
        return ["s_147_employer_match_trueup_frequency"];
      case "percent_match_vesting_immediate":
        return [
          "percent_match_vesting_1_year",
          "percent_match_vesting_2_year",
          "percent_match_vesting_3_year",
          "percent_match_vesting_4_year",
          "percent_match_vesting_5_year",
          "percent_match_vesting_6_year"
        ];
      case "age_requirement_profit_sharing":
        return [
          "age_requirement_profit_sharing_years",
          "age_requirement_profit_sharing_months"
        ];
      case "service_requirement_profit_sharing":
        return ["service_requirement_profit_sharing_measurement_number"];
      case "employer_other_dollar_maximum":
        return ["employer_other_dollar_maximum_amount"];
      case "employer_other_annual_service_reqt":
        return ["employer_other_annual_service_reqt_amount"];
      case "employer_other_vesting_immediate":
        return [
          "percent_profit_sharing_vesting_1_year",
          "percent_profit_sharing_vesting_2_year",
          "percent_profit_sharing_vesting_3_year",
          "percent_profit_sharing_vesting_4_year",
          "percent_profit_sharing_vesting_5_year",
          "percent_profit_sharing_vesting_6_year"
        ];
      case "portfolios_investments_yesno":
        return ["mo_65_rk_models_type"];
      case "managed_accounts_investments_yesno":
        return ["ma_66_ma_provider"];
      case "general_purpose_loans_yesno":
        return ["general_purpose_loans_maximum"];
      case "primary_residence_loans_yesno":
        return ["primary_residence_loans_maximum"];
      case "hardship_loans_yesno":
        return ["hardship_loans_maximum"];
      case "allow_hardship_withdrawals_yesno":
        return [
          "hardship_from_elective_deferrals_yesno",
          "hardship_from_match_any_yesno",
          "hardship_from_match_any_yesno",
          "hardship_withdrawals_employer_match",
          "hardship_from_profit_sharing_any_yesno",
          "hardship_withdrawals_employer_other"
        ];
      case "hardship_from_match_any_yesno":
        return ["hardship_withdrawals_employer_match"];
      case "hardship_from_profit_sharing_any_yesno":
        return ["hardship_withdrawals_employer_other"];
      case "in_service_withdrawals_elective_deferrals":
        return [
          "in_service_withdrawals_employer_match_yesno",
          "in_service_withdrawals_employer_match",
          "in_service_withdrawals_employer_other_yesno",
          "in_service_withdrawals_employer_other",
          "financial_wellness_exists",
          "financial_wellness_provider",
          "annual_cost_financial_wellness_service"
        ];
      case "in_service_withdrawals_employer_match_yesno":
        return ["in_service_withdrawals_employer_match"];
      case "in_service_withdrawals_employer_other_yesno":
        return ["in_service_withdrawals_employer_other"];
      case "financial_wellness_exists":
        return [
          "financial_wellness_provider",
          "annual_cost_financial_wellness_service"
        ];
      case "transition_assistance_exists":
        return [
          "transition_assistance_provider",
          "annual_cost_transition_assistance_service"
        ];
      case "plan_has_employer_matching_contributions_picklist_id":
        return [
          "age_requirement_employer_match",
          "age_requirement_match_years",
          "age_requirement_match_months",
          "service_requirement_employer_match",
          "service_requirement_match_measurement_number",
          "employer_match_type",
          "employer_match_contribution_type",
          "employer_match_funding_frequency",
          "employer_match_post_tax_contributions",
          "employer_match_true_up",
          "employer_match_yos_vary_ee",
          "match_contrib_based_yos_yesno",
          "employer_match_dollar_maximum",
          "match_on_catch_up_contributions_yesno",
          "s_147_employer_match_trueup_calculate_yesno",
          "match_require_last_day",
          "employer_match_number_tiers",
          "tiers",
          "match_dollar_limit_amount",
          "s_147_employer_match_trueup_frequency",
          "employer_match_annual_service_reqt",
          "match_hours_requirement",
          "match_excludes_overtime_comp_yesno",
          "match_excludes_bonus_comp_yesno",
          "match_excludes_commissions_comp_yesno",
          "match_excludes_shiftdifferential_comp_yesno",
          "percent_match_vesting_immediate",
          "percent_match_vesting_1_year",
          "percent_match_vesting_2_year",
          "percent_match_vesting_3_year",
          "percent_match_vesting_4_year",
          "percent_match_vesting_5_year",
          "percent_match_vesting_6_year"
        ];
      case "plan_has_profit_sharing_contributions_picklist_id":
        return [
          "age_requirement_profit_sharing",
          "age_requirement_profit_sharing_years",
          "age_requirement_profit_sharing_months",
          "service_requirement_profit_sharing",
          "service_requirement_profit_sharing_measurement_number",
          "employer_other_fixed_or_discretionary",
          "profit_sharing_allocation_method",
          "employer_other_funding_frequency",
          "profit_sharing_amount_percent",
          "employer_other_flat_dollar_amount",
          "employer_other_integrated_wage_base",
          "employer_other_integrated_base_percent_below",
          "employer_other_integrated_base_percent_above",
          "employer_other_dollar_maximum",
          "employer_other_dollar_maximum_amount",
          "profit_sharing_basic_require_last_day",
          "employer_other_annual_service_reqt",
          "employer_other_annual_service_reqt_amount",
          "profit_sharing_excludes_overtime_comp_yesno",
          "profit_sharing_excludes_bonus_comp_yesno",
          "profit_sharing_excludes_commissions_comp_yesno",
          "profit_sharing_excludes_shiftdifferential_comp_yesno",
          "employer_other_vesting_immediate",
          "percent_profit_sharing_vesting_1_year",
          "percent_profit_sharing_vesting_2_year",
          "percent_profit_sharing_vesting_3_year",
          "percent_profit_sharing_vesting_4_year",
          "percent_profit_sharing_vesting_5_year",
          "percent_profit_sharing_vesting_6_year"
        ];
    }
  },
  isNeedToReset(attr, value) {
    if (
      [
        "employer_other_vesting_immediate",
        "percent_match_vesting_immediate"
      ].includes(attr)
    )
      return +value === 1 || +value === 2;
    if (["employer_match_true_up"].includes(attr)) return value === "no";
    if (["auto_increase_available"].includes(attr)) return +value === 0 || +value === 2;
    return +value === 0;
  }
};
